import { render, staticRenderFns } from "./ExpertReply.vue?vue&type=template&id=43098836&scoped=true&"
import script from "./ExpertReply.vue?vue&type=script&lang=js&"
export * from "./ExpertReply.vue?vue&type=script&lang=js&"
import style0 from "./ExpertReply.vue?vue&type=style&index=0&id=43098836&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43098836",
  null
  
)

export default component.exports